<template>
  <div class="form__group" v-click-outside="closeItemsList">
    <input
      v-model="searchQuery"
      type="tel"
      :id="`itemsInput-${placeholder}`"
      class="form__field"
      placeholder="Country"
      autocomplete="off"
      required
      @click="openItemList = true"
      @change="openItemList = true"
    />
    <i class="input-icon" :class="iconClass"></i>
    <label :for="`itemsInput-${placeholder}`" class="form__label">{{
      selectedItem ? selectedItem[mainKey] : `Select ${placeholder}`
    }}</label>
    <div v-if="openItemList" class="countryList-container">
      <ul class="list-group">
        <li
          class="list-group-item country-item"
          v-for="item in searchResult.length > 0 || searchQuery.length > 0
            ? searchResult
            : items"
          :key="item.id"
          @click="selectItem(item)"
        >
          <span style="margin-right: 2rem" v-if="images"
            ><img
              class="country-flag"
              :src="
                '/img/flags/' +
                items
                  .find(place => place[mainKey] == item[mainKey])
                  .alpha2.toLowerCase() +
                '.png'
                  ? '/img/flags/' +
                    items
                      .find(place => place[mainKey] == item[mainKey])
                      .alpha2.toLowerCase() +
                    '.png'
                  : ''
              "
              alt="country-flag"
          /></span>
          <span>{{ item[mainKey] }}</span>
        </li>
        <li
          class="list-group-item"
          v-if="searchResult.length === 0 && searchQuery.length > 0"
        >
          Can`t find such {}
        </li>
      </ul>
    </div>
    <span
      class="reset-select"
      @click="[(selectedItem = null), (searchQuery = '')]"
      v-if="selectedItem"
      ><i class="fas fa-times"></i
    ></span>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";

export default {
  name: "CountrySelect",
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    images: {
      type: Boolean
    },
    placeholder: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      required: true
    },
    mainKey: {
      type: String,
      required: true,
      default: 'title'
    }
  },
  data() {
    return {
      searchResult: [],
      searchQuery: "",
      openItemList: false,
      selectedItem: null
    };
  },
  methods: {
    closeItemsList() {
      this.openItemList = false;
    },
    filterItems(searchQuery) {
      this.searchResult = this.items.filter(item => {
        searchQuery = searchQuery.trim();
        searchQuery = searchQuery.toLowerCase();
        let afterRegex = searchQuery.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return item[this.mainKey].toLowerCase().includes(afterRegex);
      });
    },
    selectItem(item) {
      this.selectedItem = item;
      this.searchQuery = item[this.mainKey];
      this.openItemList = false;
    }
  },
  watch: {
    searchQuery() {
      this.filterItems(this.searchQuery);
    },
    selectedItem() {
      this.$emit("select", this.selectedItem);
    }
  }
};
</script>

<style scoped lang="scss">
$bgColor: #009788;
$borderColor: #01756a;
.form__group {
  position: relative;
  padding: 15px 0 0;
  margin-top: 10px;
}
.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #d2d2d2;
  outline: 0;
  font-size: 16px;
  color: #212121;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;
}

.form__field::placeholder {
  color: transparent;
}

.form__field:placeholder-shown ~ .form__label {
  font-size: 16px;
  cursor: text;
  top: 20px;
}

label,
.form__field:focus ~ .form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 12px;
  color: #9b9b9b;
}

.form__field:focus ~ .form__label {
  color: $bgColor;
}
.form__field:focus ~ .input-icon {
  color: $bgColor;
}

.form__field:focus {
  padding-bottom: 6px;
  border-bottom: 2px solid $bgColor;
}
/*Inputs custom style ends ############################################################# */
.modal-content {
  padding: 5%;
}
.input-icon {
  position: absolute;
  left: -30px;
  top: 25px;
  font-size: 1.9rem;
}
.countryList-container {
  max-height: 250px;
  //min-height: 100px;
  overflow-y: auto;
  position: absolute;
  background-color: white;
  width: 100%;
  z-index: 1;
}

/*Scroll custom style starts ############################################################# */

.countryList-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.countryList-container::-webkit-scrollbar {
  width: 7px;
  background-color: $bgColor;
  /*display: none;*/
}

.countryList-container::-webkit-scrollbar-thumb {
  background-color: $bgColor;
  border: 2px solid $borderColor;
  border-radius: 5px;
}
/*Scroll custom style ends ############################################################# */

.country-item {
  color: $bgColor;
  transition: all 0.2ms ease-in-out;
}
.country-item:hover {
  background-color: #ebebeb;
  cursor: pointer;
}
.reset-select {
  position: absolute;
  cursor: pointer;
}
.reset-select:hover {
  color: grey;
}
</style>
